import { useMemo } from 'react';
import { TEMPLATE_SENDERS_URL } from 'api/TemplatePickerAPI';
import { SmsSender, SmsEsps } from 'modules/senders/types';
import { useRestQuery } from 'utils/hooks/api';

export const useSmsSendersWithESP = (): Record<string, SmsSender & { esp: SmsEsps }> => {
  const { data } = useRestQuery(TEMPLATE_SENDERS_URL);

  const smsSendersWithEsps: Record<string, SmsSender & { esp: SmsEsps }> = useMemo(() => {
    if (data) {
      const EspsById = Object.fromEntries(data?.smsEsps?.map((esp: SmsEsps) => [esp.id, esp]));
      return Object.fromEntries(
        data.smsSenders.map((sender: SmsSender) => [
          sender.id,
          { ...sender, esp: EspsById[sender.espAccountId] },
        ]),
      );
    }
    return {};
  }, [data]);

  return smsSendersWithEsps;
};
